import React, { useState } from "react";
import { MonthPicker } from "./month_picker/MonthPicker/MonthPicker";
import { MonthInput } from "./month_picker/MonthInput/MonthInput";

function MonthFormField({ label, value, onChange, error = null }) {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  return (
    <>
      <label className="form-label fw-medium mb-1">{label}</label>
      {error && <div className="text-danger small mb-1">{error}</div>}
      <MonthInput
        selected={value}
        setShowMonthPicker={setIsPickerOpen}
        showMonthPicker={isPickerOpen}
        size="small"
      />
      {isPickerOpen && (
        <MonthPicker
          setIsOpen={setIsPickerOpen}
          selected={value}
          onChange={onChange}
        />
      )}
    </>
  );
}

export default MonthFormField;
